import * as React from 'react'
import {observer} from 'mobx-react'
import {keys} from 'lodash'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import {EpikQueryParam} from '@raisenow/epik'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {WidgetView} from '../../../lib/WidgetView'
import {SubscriptionCancelBlock} from '../common/blocks/SubscriptionCancelBlock'
import {SubscriptionCancelledBlock} from '../common/blocks/SubscriptionCancelledBlock'
import {SubscriptionPaymentMethodUpdateBlock} from '../common/blocks/SubscriptionPaymentMethodUpdateBlock'
import {SubscriptionInfoBlock} from './blocks/SubscriptionInfoBlock'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionInfoWidget = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {uiTransitionTimeout: timeout} = api.computedConfig
  const param = api.currentLocation.params[EpikQueryParam.VIEW]
  const blocks = {
    [WidgetView.SUBSCRIPTION_CANCEL]: SubscriptionCancelBlock,
    [WidgetView.SUBSCRIPTION_PAYMENT_METHOD_UPDATE]: SubscriptionPaymentMethodUpdateBlock,
    [WidgetView.SUBSCRIPTION_CANCEL_RESULT]: SubscriptionCancelledBlock,
  }
  const key = param && keys(blocks).indexOf(param) !== -1 ? param : 'default'
  const Block = blocks[key] || SubscriptionInfoBlock

  return (
    <div className="subscription-widget">
      <TransitionGroup component={null}>
        <CSSTransition key={key} timeout={timeout} appear classNames="fade-in">
          <Block />
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
})
